import { Transaction } from "./Transaction";
import { CashTransaction } from "./CashTrasanction";
import { TransactionType, TransFields } from "../shared/Consts"
import { EventEmitter } from "events";
import { Price } from "./Price";
import Portfolio from "./Portfolio";
import Utils from "../portlibs/PortUtils";
import axios from "axios"
import Crypto, {RSA} from "../libs/Crypto"
import GICHolding from "./GICHolding";
import Prices from "./Prices";
import IPortfolio from "../shared/IPortfolio";
import Holding from "./Holding";
import * as _ from "lodash"
import { ITransRow } from "../shared/ITransaction";
import { ConnectableObservable } from "rxjs";

const public_pem = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAzI4rzXzGBPFrAIj0VH53
UJ0dLl9BNeD/JkBk4FAek+YZ0Eyx17WUyMrixWk6Ihg5oTbRN6wCxVaKTGJqGjvv
zOgbobpPKPJlQkFOxMQFH4dsKnXuEG0sy2Ib1BjxRfFyKjC9mRgltKTEyp5qCmSg
B6chrKiVKFbjYJBRNV8gpwViMvUISNBijh+/SnTKFtdxWqPstYx0b3jLvklnOLFI
vCufdxsmRrQi99VB/8aPElP3MN7+C/eWDbXH5+8d5WWCH0viDtilImZSvsQg41BG
cOwlVdwYFx/1hShi/5IncKfW92ZhUgCUoZ+kaZdpEuZGYN0ODMJqmzufGqpvqeHm
7/SlaBd8j5M6YKZkB5uSmUIb3C/ZX+pOub9qm/W25FEwNYXv2hfPBV7PjP7Uzs3q
BbSpCC+gM2qa0Scc4q0Ro75bsXxidhqQ0TzG9sH+HEhIbTim9rt62PXKdg/qxEfR
sndsN7oQagN4JkW6/lmWoBLS7VBK4JzSa1u/Qt0h12KyCLhQKGhLeQF+z62TzkXl
iwCkiXSQVFUGSHniUcOIOZP1W7CIkupjiw6Pb9T212W3HIil9mVcsFKsMXi5wPd9
JPrafnNYAEwpsLwk+F1uiLz1vUeEqtzN5rzJZ91VlCRVAFnP99H9rfx+1YBmEwza
iH9y2Nj1rFma7q466iJfj58CAwEAAQ==
-----END PUBLIC KEY-----`

export interface IAccount {
    id:number;
    name:string;
}
export interface IUser {
    _id:string;
    email:string;
    sak:string;
    name:string;
}
export enum AccountTypes {
    cash = 0,
    rrsp = 1,
    tfsa = 2
}
export default class PortAccount extends EventEmitter {
    static i = new PortAccount();

    private _sak:string|null = null;
    private _userId:string|null = null;
    private _busy = false;
    private _crypto:RSA = new RSA()
    private _portfolio:Portfolio = new Portfolio()
    private _json:IPortfolio|undefined

    get headers(){return {headers:{sak:this._sak!,"content-type":"application/json"}}}
    get portfolio(){return this._portfolio}

    constructor(){
        super();
        super.setMaxListeners(100);
        (window as any).account = this;
    }

    getHeaders(headers?:Record<string,string>) {
        return {headers:{sak:this._sak,...headers}}
    }
    
    async auth() {
        if (this._busy) return
        else this._busy = true

        const sak = this._getSak();
        if (!sak) this.emit("auth", false)
        else return this._auth(sak)
    }

    private async _auth(sak:string) {
        try {
            const {data:portfolio} = await axios.get("/1/me", {headers:{sak}})
            this._sak = sak
            localStorage.setItem("uport", JSON.stringify({sak}))
            await this._setPortfolio(portfolio)
            this.emit("auth", true)
        } catch(status) {
            this.emit("auth", false)
        } finally {
            this._busy = false
        }    
    }

    private _getSak(){
        try { 
            const url = new URL(document.location.href);
            const sak = url.searchParams.get("sak")
            return sak || JSON.parse(localStorage.getItem("uport")||"").sak 
        }
        catch(e){ return "" }
    }

    async transferAccount(from:number, to:number){
        const transactions:Transaction[] = [
            ...this.portfolio.cash(0, from).transactions,
            ...this.portfolio.cash(1, from).transactions
        ]
        for(const holding of this.portfolio.holdings){
            for(const trans of holding.transactions){
                if (trans.accountId==from) {
                    transactions.push(trans)
                }
            }
        }
        const postfix = `Xfer ${Utils.formatDate('yyyy-MM-dd', new Date())}`
        for(const trans of transactions){
            const t = trans.clone()
            t.accountId = to
            t.note = t.note + (t.note ? " " : "") + postfix
            await this._updateTransaction(trans.holding, trans.clone())
        }
    }
    async _setPortfolio(portfolio: IPortfolio){
        localStorage.setItem("portfolio", JSON.stringify(portfolio))
        await Prices.i.load(Object.keys(portfolio.holdings))
        this._portfolio = new Portfolio(portfolio)
        this._json = portfolio
        this.emit("refresh", this._portfolio)
        return this._portfolio
    }

    get authenticated(){ return this._sak ? true : false }
    get userId(){return this._userId}
    
    async addAccount(name:string,type:string) {
        const {data:portfolio} = await axios.put("/1/users/me/accounts/" + type, JSON.stringify(name), this.headers)
        return this._setPortfolio(portfolio)
    }
    async updateAccount(id:number,name:string,type:number){
        await axios.post("/1/users/me/accounts", {[id]:{name,type}}, this.headers)
    }
    async loginEmail(email:string, pass:string) {
        await this._crypto.init(public_pem)
        const password = await this._crypto.encrypt(await Crypto.sha256(pass))
        const {data:user} = await axios.post("/1/users/login", {email,password})
        return this._auth(user.sak)
    }
    async createUser(email:string, pass:string, name:string){
        await this._crypto.init(public_pem)
        const password = await this._crypto.encrypt(await Crypto.sha256(pass))
        const {data:user} = await axios.post("/1/users/register", {email,password,name})
        return this._auth(user.sak)
    }
    async setPassword(pass:string){
        await this._crypto.init(public_pem)
        const password = await this._crypto.encrypt(await Crypto.sha256(pass))
        return axios.put("/1/me/password", JSON.stringify(password), this.getHeaders({"content-type":"application/json"}))
    }
    async update(portfolio:Portfolio, trans:Transaction, updateCash:boolean, settlement:number){
        let data = await this._update(trans)
        if (updateCash && !trans.holding.isCash){
            return await this.updateCash(portfolio, trans, settlement)
        }
        else return data
    }
    async switchTicker(old:Transaction, ticker:string) {
        ticker = ticker.toUpperCase()
        if (old.holding.isCashEq) {
            const trans = (old.holding as GICHolding).gicTransactions
            for(const t of trans){
                const n = t.clone()
                n._id = ""
                await this._update(n, ticker)
            }
            for(let i=trans.length-1; i>=0; i--) {
                await this.deleteTrans(trans[i])
            }
        }else{
            const n = old.clone()
            n._id = ""
            await this._update(n, ticker)
            await this.deleteTrans(old)
        }
    }
    async updateTicker(old:string, ticker:string){
        const holding = this.portfolio.holding(old)
        if (!holding) return

        const transactions = holding.transactions.slice(0)
        for(const trans of transactions) {
            await this.switchTicker(trans, ticker)
        }
        console.log("done")
    }
    async deleteTrans(trans:Transaction){
        if (!this._json) throw {status:401,msg:"Not authorized"}
        await axios.delete(`/1/users/me/holdings/${trans.holding.id}/${trans._id}`, this.headers)
        _.remove(this._json.holdings[trans.holding.id], t => t._id==trans._id)
        return this._setPortfolio(this._json)
    }
    async tax(portfolio:Portfolio, trans:Transaction) {
        const cashTrans = new CashTransaction(portfolio!.cash(1), {
            [TransFields.date] : Utils.formatDate("yyyy-MM-dd", trans.date),
            [TransFields.type] : TransactionType.adjust,
            [TransFields.quantity] : -trans.quantity*0.15,
            [TransFields.price] : 1,
            [TransFields.note] : trans.holding.id + " Tax",
            [TransFields.account] : trans.accountId
        })
        return this._update(cashTrans)
    }
    async updateCash(portfolio:Portfolio, trans:Transaction, settlement:number){
        const cash = settlement ? portfolio!.cash(0) : portfolio!.cash(trans.holding.currency)
        let cashNote = trans.holding.id;
        let qty = 0;
        if (trans.isBuy||trans.isSell) {
            qty -= (settlement||trans.quantity*trans.price);
            cashNote += " " + (trans.quantity>0 ? "Buy":"Sell")
        }
        else if (trans.isReinvest) {
            qty -= (settlement || trans.quantity*trans.price);
            cashNote += " Reinvest";
        }
        else {
            if (trans.isDividend) cashNote += " Dividend";
            qty = (settlement || trans.quantity*trans.price);
        }
        const cashTrans = new CashTransaction(cash, {
            [TransFields.date] : Utils.formatDate("yyyy-MM-dd", trans.date),
            [TransFields.type] : TransactionType.adjust,
            [TransFields.quantity] : qty,
            [TransFields.price] : 1,
            [TransFields.note] : cashNote,
            [TransFields.account] : trans.accountId
        })
        return this._update(cashTrans)
    }
    async updatePrice(price:Price){
        await axios.post(`/1/prices/${price.id}`, price.payload, this.headers)
        Prices.i.update(price)
        this._setPortfolio(JSON.parse(localStorage.getItem("portfolio") as string))
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // helpers
    private async _update(trans:Transaction, ticker?:string) {
        if (!this._json) throw {status:401,msg:"not authorized"}
        if (!ticker) ticker = trans.holding.id
        const _trans = (trans._id ? 
            await axios.post<ITransRow>(`1/users/me/holdings/${ticker}/${trans._id}`, trans.payload, this.headers) : 
            await axios.post<ITransRow>(`/1/users/me/holdings/${ticker}`, trans.payload, this.headers)).data
        
        return this._updateTransaction(trans.holding, _trans)
    }
    private _updateTransaction(holding:Holding, _trans:ITransRow){
        const ticker = holding.id
        const holdings = this._json!.holdings

        if (ticker in holdings) {}
        else holdings[ticker] = []
        
        const index = _.findIndex(holdings[ticker], t => t._id==_trans._id)
        if (index>=0) holdings[ticker][index] = _trans
        else holdings[ticker].push(_trans)

        return this._setPortfolio(this._json!)
    }
}
